/**
 * API
 * @type {string}
 */
export const BASE_URI = 'https://longswap.app';

/**
 * Websocket
 * @type {string}
 */
export const WS_URL = 'wss://longswap.app/ws'

/**
 * Main Route
 * @type {string}
 */
export const SWAP_ROUTER = '0x8397a6381399320f8da9F568FF2a21D26575CfdD' //'0x99437C49Cf53D541D9B73D4F4E4dAE47aF20746D'

/**
 * BNBX
 * @type {string}
 */
export const BNBX = '0xF662457774bb0729028EA681BB2C001790999999'

/**
 * BNBX_LP
 * @type {string}
 */
export const BNBX_LP = '0xAa3f145f854e12F1566548c01e74c1b9d98c634d'

/**
 * BNBX_long
 * @type {string}
 */
export const BNBX_LONG = '0x1450872ca5443Ef397997D8C4bAAAFEDc0b5B36b'

/**
 * Stake Pool
 * @type {string}
 */
export const STAKING = '0xcE46D14fBA6856069D08de7f29E584b65f7c9146'


/**
 * Stake Pool
 * @type {string}
 */
export const STAKING_LONG = '0x9CB7bce0fC093Be7C35F55b34A7613f1cBCd4e09'

/**
 * Stake Pool
 * @type {string}
 */
export const STAKING_NO1 = '0x8C6Fe902aaa28A4eB33cF7eE04F53F242D4bD086'

/**
 * Stake Pool
 * @type {string}
 */
export const Mining = '0xFaF6B1b79fd6B6a906e25a8A3387b9d76B0c7F6D'

/**
 * Stake Pool
 * @type {string}
 */
export const BNBvip = '0xF19601f2f9D81b48B7F5F4ae119Eaf7a3E7037a8'

/**
 * ProjectShow
 * @type {string}
 */
export const ProjectShowAddress = '0x68856DD8FCC45fdeB64A36537bA3c6e1B503169E'

/**
 * ProjectShow
 * @type {string}
 */
export const W3SIGN = '0x6DCCe2024f4dcc8232BfA994451f5eAd5e890764'

export const ADDNUM = 20000;

export const REFERRALPoint = "0xe9008E0FbF19F9886C35394b1E4F66d2b64F409A"; // 10%

export const CommissionManager = "0xE50Ea137ba052Ec9Ab81953179b9B48dBAe69C6a"; 

export const MIN = 0.0006;
export const MAX = 0.00085;

export const W3change = "0x721fE243F513620606b8d2d56e842eea266Bf6cB";

export const W3Token="0x03674395457AA35761Ef972CC94861B5DC604B86"

export const W3NFT="0x4444d8DB491EF88d3371883A0A3147c0a8F3F493"

export const W3ControlMachine="0x8bC2F8008fC07DB4d2381995Bb03D82CFFAF6e79"

export const W3Machine="0xBEAFEC2D2F30782eE8c8BA621A6fa85160064EC7"

export const W3MinerNFT="0xF637Ac3A6978172163e55E977413627E6772515c"

export const W3NFTDividend="0xcE299E8423Bf5e400DFbdD074ACBab1eE6c86ABe"

export const W3TeamNum="0xb5cB3c1aabBf42277728aD318Dd7C5A64508b0ff"

export const MiningWithdraw="0x669106dd639cfaaeb74796f064C2682f53acc0e2"

export const ad=["0x880B25AE61568A6672279A3f49896F6949dC5175",
                "0x0F6C77a9E78932F81f24f85edAa36d46472Bac9d",
                "0x01b0E9dc0b549B7350f53D50f1Dfe68E83676767",
                "0x7E16c1Acbf265554308b08E66Aa3F15C149D8322"];

export const ido = "0xe5135606629553089c123d3d9670f58Fd88B4E97";

export const lpclaimer = "0x3e73a235dc23d0f5D675270B7A50F9c0Cf7cc3b1";
export const lpDividend = "0xcc05C491744d6E42514284d251DF2Cf538569a97";